import { render, staticRenderFns } from "./EtransactDataWallet.vue?vue&type=template&id=6b07cff1&scoped=true"
import script from "./EtransactDataWallet.vue?vue&type=script&lang=js"
export * from "./EtransactDataWallet.vue?vue&type=script&lang=js"
import style0 from "./EtransactDataWallet.vue?vue&type=style&index=0&id=6b07cff1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b07cff1",
  null
  
)

export default component.exports